import { NotificationState } from '@/apps/profile/components/WorkplaceSettings/Notifications';
import { create } from 'zustand';

// Opt-in placeholder shown only until the real preferences load from the server
// (see WorkplaceLayout's fetch + workspaceLoaded below). Email/SMS must default
// false here — defaulting them true let a toggle saved before that fetch resolved
// silently re-enable channels the user had already disabled on the backend.
const defaultNotifications = {
  room: {
    app: false,
    browser: false,
    email: false,
    sms: false,
    whatsapp: false,
  },
  building: {
    app: false,
    browser: false,
    email: false,
    sms: false,
    whatsapp: false,
  },
  messages: {
    app: false,
    browser: false,
    email: false,
    sms: false,
    whatsapp: false,
  },
};

export const useUserPreferencesStore = create<{
  preferences: Record<string, any>;
  setPreferences: (prefs: Record<string, any>) => void;
  clear: () => void;
  getNotifications: () => NotificationState | undefined;
  setNotifications: (notifications: NotificationState) => void;
  getSmsAgreed: () => boolean;
  setSmsAgreed: (agreed: boolean) => void;
  getWhatsappAgreed: () => boolean;
  setWhatsappAgreed: (agreed: boolean) => void;
  // True once the real workspace preferences have been fetched from the server
  // (or that fetch has failed/been skipped for a guest). Gates Notifications.tsx
  // so it can't save the placeholder defaults over real saved preferences.
  workspaceLoaded: boolean;
  setWorkspaceLoaded: (loaded: boolean) => void;
}>((set, get) => ({
  preferences: {
    workspace: {
      settings: {
        notifications: {
          online: defaultNotifications,
          away: defaultNotifications,
          offline: defaultNotifications,
        },
      },
    },
  },
  setPreferences: (prefs) => set({ preferences: prefs }),
  clear: () => set({ preferences: {}, workspaceLoaded: false }),
  workspaceLoaded: false,
  setWorkspaceLoaded: (loaded) => set({ workspaceLoaded: loaded }),
  getNotifications: () => get().preferences?.workspace?.settings?.notifications,
  setNotifications: (notifications) => {
    const prefs = get().preferences;
    const newPrefs = {
      ...prefs,
      workspace: {
        ...prefs.workspace,
        settings: {
          ...prefs.workspace?.settings,
          notifications,
        },
      },
    };

    console.log('Updated Preferences:', newPrefs);

    set({ preferences: newPrefs });
  },
  getSmsAgreed: () => get().preferences?.workspace?.settings?.smsAgreed ?? false,
  setSmsAgreed: (agreed) => {
    const prefs = get().preferences;
    set({
      preferences: {
        ...prefs,
        workspace: {
          ...prefs.workspace,
          settings: {
            ...prefs.workspace?.settings,
            smsAgreed: agreed,
          },
        },
      },
    });
  },
  getWhatsappAgreed: () => get().preferences?.workspace?.settings?.whatsappAgreed ?? false,
  setWhatsappAgreed: (agreed) => {
    const prefs = get().preferences;
    set({
      preferences: {
        ...prefs,
        workspace: {
          ...prefs.workspace,
          settings: {
            ...prefs.workspace?.settings,
            whatsappAgreed: agreed,
          },
        },
      },
    });
  },
}));
